<template>
  <adSkeleton
    id-name="adup_deals_detail_contentAd_top"
    :placement-keys="placementKeys"
    :query="query"
    :locale="locale"
  />
</template>

<script>
import adSkeleton from '../../adSkeleton.vue'

export default {
  components: {
    adSkeleton
  },
  props: {
    query: {
      type: String,
      default: '',
    },
    locale: {
      type: String,
      default: '',
    },
    placementKeys: {
      default: () => {
        return {
          es: [
            '5318b8068b1c104a34ef10b284159973', // Desktop
            '790084676eb87d17fb8e519d12111e38' // Mobile
          ],
        }
      }
    }
  }
};
</script>

<style lang="scss">
.adup_deals_detail_contentAd_top {
  width: 100%;
  height: rem(360);

  @media screen and (min-width: 500px) {
    height: rem(100);
  }
}
</style>
